<section>
  <div class="mb--sm">
    <p class="text-small text-uppercase bold color--dark-blue-grey lineheight--condensed mb--none">
      {{ 'App.Admin.Dashboard.ServiceQuality.Title' | translate }}
    </p>
    @if (report && hasData) {
      <p class="mt--xxs mb--none text-xs color--blue-grey">
        {{ report.responseCount | number }}
        {{ 'App.Admin.Dashboard.ServiceQuality.Responses' | translate }}
      </p>
    }
  </div>

  @if (isLoading) {
    <div class="display-flex justify-content-center my--xl">
      <mat-spinner class="primary-spinner"></mat-spinner>
    </div>
  } @else if (report) {
    <app-report-data-warning
      [comparisonPeriod]="report.comparisonPeriod"
      [dataSince]="report.dataSince"
      [selectedRange]="selectedRange">
    </app-report-data-warning>

    @if (hasData) {
      <div class="row">
        <div class="column--12 column-lg--8 display-flex">
          <mat-card class="flex-1">
            <mat-card-header>
              <mat-card-title>{{ 'App.Admin.Dashboard.ServiceQuality.ExperienceRating' | translate }}</mat-card-title>
              <mat-card-subtitle>{{ 'App.Admin.Dashboard.ServiceQuality.ExperienceQuestion' | translate }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <div class="mb--md">
                <div class="display-flex row--valign-bottom row-gap--xs">
                  <span class="display-flex row--valign-baseline row-gap--xs">
                    <span class="metric-value bold color--navy lineheight--none">{{ report.averageRating | number:'1.1-1' }}</span>
                    <span class="text-larger bold color--dark-blue-grey">/ 5</span>
                  </span>
                  @if (report.averageRatingDifference !== null) {
                    <app-comparison-badge
                      [value]="report.averageRatingDifference"
                      [digits]="1">
                    </app-comparison-badge>
                  }
                </div>
              </div>

              <div class="rating-distribution row-gap--xs">
                @for (rating of ratingDistribution; track rating.rating) {
                  <div class="rating-row row-gap--sm rating-{{ rating.rating }}">
                    <span class="text-larger color--dark-blue-grey nobr">{{ ratingStars(rating.rating) }}</span>
                    <span class="rating-track bg--lighter-grey">
                      <span class="rating-fill display-block h-100" [style.width.%]="rating.percentage ?? 0"></span>
                    </span>
                    <span class="text-small align-right color--dark-blue-grey">
                      {{ rating.percentage | number:'1.0-1' }}%
                    </span>
                  </div>
                }
              </div>

              <p class="mt--md mb--none text-small color--dark-blue-grey">
                <strong>{{ report.ratedFourOrHigherPercentage | number:'1.0-1' }}%</strong>
                {{ 'App.Admin.Dashboard.ServiceQuality.RatedFourOrHigher' | translate }}
              </p>
            </mat-card-content>
          </mat-card>
        </div>

        <div class="column--12 column-lg--4 display-flex cross-sell-column">
          <mat-card class="stats-card flex-1">
            <mat-card-header>
              <mat-card-title>{{ 'App.Admin.Dashboard.ServiceQuality.InStoreCrossSell' | translate }}</mat-card-title>
              <mat-card-subtitle>{{ 'App.Admin.Dashboard.ServiceQuality.PurchaseQuestion' | translate }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="display-column-flex flex-1 justify-content-center">
              <div class="display-flex row--valign-bottom row-gap--xs justify-content-center">
                <span class="metric-value bold color--navy lineheight--none">
                  {{ report.inStorePurchasePercentage | number:'1.0-1' }}%
                </span>
                @if (report.inStorePurchasePercentageDifference !== null) {
                  <app-comparison-badge
                    [value]="report.inStorePurchasePercentageDifference"
                    [digits]="1">
                  </app-comparison-badge>
                }
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    } @else {
      <mat-card>
        <mat-card-content class="display-flex justify-content-center py--lg">
          <app-no-data
            [message]="(report.dataSince
              ? 'App.Admin.Dashboard.ServiceQuality.NoResponses'
              : 'App.Admin.Dashboard.ServiceQuality.NoReportingData') | translate">
          </app-no-data>
        </mat-card-content>
      </mat-card>
    }
  }
</section>
